
export const regRule = {
    nameCN:/^[~!@#$^&*()=|{}':;',\-\[\].<>\/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？\u4e00-\u9fa5]+$/,
    name:/^[a-zA-Z\u4e00-\u9fa5]+$/,
    enNum:/^[a-zA-Z0-9]*$/,
    enNumF:/^[a-zA-Z0-9~!@#$^&*()=|{}':;',\-\[\].<>\/?]*$/,
    mobileRegx:/^1[3|4|5|7|8][0-9]{9}$/,
    emailRegx:/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
    landlinePhone:/^([0-9]{3,4}-)?[0-9]{7,8}$/,
    bigNum:/^([1-9][0-9]{0,1}|[1][0-9]{1,2}|[2][0-4][0-9]|250)(\.\d{0,3})?$/,
    byte10:/^[\s\S]{10,}$/
};


//深度copy
export function depCopy(obj){
    switch(Object.prototype.toString.call(obj)){
        case '[object Array]':
            return obj.map((e)=>{
                if(typeof e==='object'){
                    return Object.assign({},e);
                }else{
                    return e;
                }
            })
            break;
        case '[object Object]':
            return Object.assign({},obj);
            break;
        default:
            return obj;
    }
}

//时间format
export function dateFormat(){
    Date.prototype.Format = function (fmt) { //
        var o = {
            "M+": this.getMonth() + 1, //Month
            "d+": this.getDate(), //Day
            "h+": this.getHours(), //Hour
            "m+": this.getMinutes(), //Minute
            "s+": this.getSeconds(), //Second
            "q+": Math.floor((this.getMonth() + 3) / 3), //Season
            "S": this.getMilliseconds() //millesecond
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    };
}


//身份证号合法性验证 
//支持15位和18位身份证号
//支持地址编码、出生日期、校验位验证
export function IdentityCodeValid(code) {
    var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
    var tip = "";
    var pass= true;
    
    if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)){
        tip = "身份证号格式错误";
        pass = false;
    }
    
   else if(!city[code.substr(0,2)]){
        tip = "地址编码错误";
        pass = false;
    }
    else{
        //18位身份证需要验证最后一位校验位
        if(code.length == 18){
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
            //校验位
            var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++)
            {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            var last = parity[sum % 11];
            if(parity[sum % 11] != code[17]){
                tip = "校验位错误";
                pass =false;
            }
        }
    }
    return pass;
}


//H5实现浏览器全屏API(全屏进入和全屏退出)
//进入全屏
export function requestFullScreen() {
    try{
        var de = document.documentElement;
        if (de.requestFullscreen) {
            de.requestFullscreen();
        } else if (de.mozRequestFullScreen) {
            de.mozRequestFullScreen();
        } else if (de.webkitRequestFullScreen) {
            de.webkitRequestFullScreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    }catch(e){

    }
    
}
//退出全屏
export function exitFullscreen() {
    var de = document;
    if (de.exitFullscreen) {
        de.exitFullscreen();
    } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen();
    } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen();
    }
}


/*** 获取用户信息：是否已经登陆 ***/
/*******solarman-h5-userInfo md5 加密 32 位小写 ： e148e9ef7fbd5290e868fa945d14fbb9 *********************** */
export function getPathParam(name){
    let pathPram = null;
    if(window.location.search.split('?')[1]){
        pathPram = window.location.search.split('?')[1];
    } else if(window.location.hash.split('?')[1]) {
        pathPram = window.location.hash.split('?')[1];
    }

    if(pathPram){
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象=
        var r =pathPram.match(reg);  //匹配目标参数
        if (r != null) return decodeURIComponent(r[2]);
        else return null; //返回参数值
    } else {
        return null;
    }
}

export function getUserInfo(){
    return JSON.parse(localStorage.getItem('e148e9ef7fbd5290e868fa945d14fbb9'))|| {uid:null,userId:null}
}
/*** 更新用户信息 ***/
export function updateUserInfo(u){
    localStorage.setItem('e148e9ef7fbd5290e868fa945d14fbb9',JSON.stringify(u))
}

export function getSessionUserInfo(){
    return JSON.parse(sessionStorage.getItem('e148e9ef7fbd5290e868fa945d14fbb9'))|| {uid:null,userId:null}
}
/*** 更新用户信息 ***/
export function updateSessionUserInfo(u){
    sessionStorage.setItem('e148e9ef7fbd5290e868fa945d14fbb9',JSON.stringify(u))
}


// WEBPACK FOOTER //
// ./src/util/util.js